import { Component, Input, OnInit } from '@angular/core';
import { faEye } from '@fortawesome/pro-solid-svg-icons';

import { PcgTableColumn } from '../../pcg-table-column.interface';

@Component({
    selector: 'pcg-button-hide-show',
    templateUrl: './button-hide-show.component.html',
    styleUrls: ['./button-hide-show.component.scss'],
    standalone: false
})
export class ButtonHideShowComponent implements OnInit {

	@Input() columnDefs!: Map<string, PcgTableColumn>;

	colVisActive = false;

	// Fa icons
	faIconName = { faEye };

	getColDefs = () => Array.from(this.columnDefs.keys());

	ngOnInit() {
		this.columnDefs.forEach((value, key) => {
			if (value.isVisible !== false) {
				value.isVisible = true;
			}
		});
	}
}